import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { homeListingService } from '@/api/services/homeListingService'

export function useHomeListings(p?: Parameters<typeof homeListingService.list>[0]) {
  return useQuery({ queryKey: ['home-listing', p], queryFn: () => homeListingService.list(p), staleTime: 30_000 })
}
export function useCreateUpdateHomeListing() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (d: Record<string, unknown>) => homeListingService.createUpdate(d), onSuccess: () => qc.invalidateQueries({ queryKey: ['home-listing'] }) })
}
export function useDeleteHomeListing() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: number) => homeListingService.delete(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['home-listing'] }) })
}
